import { BadgeIcon, BadgeImage, BadgeProps, JustifyContent, TooltipProps, BadgeVariant, Size } from '@drone-js/core';
import { MarginType } from '@drone-js/theme';
import { BadgeType } from 'gql/autogen/BadgeType';
import { LoyaltyTier } from 'component/common/Badge/LoyaltyBadge';

export interface BadgeWithTooltipProps {
    badge: BadgeProps & { loyaltyTier?: LoyaltyTier };
    tooltip?: TooltipProps;
    badgeType: BadgeType;
}

export interface ActivityBadgeProps {
    variant?: BadgeVariant;
    labelTextCmsId: number;
    tooltipTextCmsId?: number;
    leadingAsset?: BadgeImage | BadgeIcon;
    trailingAsset?: BadgeIcon;
    labelVariant?: 'tooltip';
}

export interface BadgeMargin {
    mt?: MarginType;
    mb?: MarginType;
    ms?: MarginType;
    me?: MarginType;
}
export interface ActivityBadgeCategoryProps {
    variant?: BadgeVariant;
    maxBadges?: { s?: number; m?: number; l?: number };
    showSummary?: { s?: boolean; m?: boolean; l?: boolean };
    boxMargin?: { s?: BadgeMargin; m?: BadgeMargin; l?: BadgeMargin };
    badgeMargin?: { s?: BadgeMargin; m?: BadgeMargin; l?: BadgeMargin };
    badgeMaxWidth?: { s?: Size; m?: Size; l?: Size };
    contentJustification?: JustifyContent;
}

export enum ActivityBadgeCategory {
    DEAL = 'deals',
    HIGHLIGHT = 'highlight',
    KEY_ATTRIBUTES = 'keyAttributes',
    PROMOCODE = 'promocodes',
    UNKNOWN = 'unknown',
}
